<template>
  <v-dialog 
  v-model="dialog" 
  scrollable 
  persistent 
  :fullscreen="$vuetify.breakpoint.xs" 
  max-width="800px"
  :content-class="contentClass">

    <v-card>
      <div>
        <v-row class="pa-2">

          <v-spacer></v-spacer>
          <v-btn @click="close">
            Close
          </v-btn>
        </v-row>
      </div>

      <div style="overflow: auto; flex: 1;">
        <dialog-card v-if="dialog" :column_key="column_key"></dialog-card>
      </div>
    </v-card>

  </v-dialog>
</template>

<script>
import DialogCard from './Card'

export default {
  components: {
    DialogCard
  },
  data () {
    return {
      dialog: false,
      loading: false,
      column_key: ''
    }
  },
  computed: {
    contentClass () {
      return 'c-dialog-border-13' + (this.$vuetify.breakpoint.smAndUp ? ' dialog-height-90vh' : '')
    }
  },
  methods: {
    open (column_key) {
      // column_key = 'invoice_column_schema' for example
      this.column_key = column_key
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    save () {
      
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .dialog-height-90vh {
  max-height: 90vh;
}
</style>

